import React, { useEffect, useMemo, useState } from 'react';

const DEFAULT_GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÜẞ0123456789#';

const randomGlyph = (glyphs) => glyphs[Math.floor(Math.random() * glyphs.length)] || '';

function DecodeText({ text = '', className = '', trigger = 0 }) {
    const [displayText, setDisplayText] = useState(text || '');
    const glyphs = useMemo(() => DEFAULT_GLYPHS.split(''), []);

    useEffect(() => {
        const finalText = text || '';
        if (!finalText) {
            setDisplayText('');
            return undefined;
        }

        const chars = Array.from(finalText);
        const start = performance.now();
        const speedFactor = 2;
        const delays = chars.map((_, index) => index * (40 + Math.random() * 40) * speedFactor);
        const durations = chars.map(() => (300 + Math.random() * 250) * speedFactor);
        const totalDuration = Math.max(...durations.map((duration, index) => duration + delays[index]));

        let rafId = null;
        const tick = (now) => {
            const elapsed = now - start;
            const next = chars
                .map((char, index) => {
                    const delay = delays[index];
                    if (elapsed < delay) {
                        return randomGlyph(glyphs);
                    }
                    const progress = elapsed - delay;
                    if (progress >= durations[index]) {
                        return char;
                    }
                    return randomGlyph(glyphs);
                })
                .join('');
            setDisplayText(next);
            if (elapsed < totalDuration) {
                rafId = requestAnimationFrame(tick);
            } else {
                setDisplayText(finalText);
            }
        };

        rafId = requestAnimationFrame(tick);
        return () => {
            if (rafId) {
                cancelAnimationFrame(rafId);
            }
        };
    }, [text, trigger, glyphs]);

    return <span className={`decode-text ${className}`.trim()}>{displayText}</span>;
}

export default DecodeText;
